<template>
    <div class="fault-bar">
        <b-row no-gutters class="text-deposit">
            <b-col cols="12" class="">
                <b-row no-gutters> 
                    <b-col cols="6" class="text-left">
                        Deposits:
                        <div>
                            <span
                                :id="`deposit-${keyItem}`"
                                v-bind:class="getNumberClass(fixDeposit.length)"
                            >
                                {{ moneyFormat(fixDeposit) }}
                            </span>
                            <span
                                style="text-transform:uppercase"
                                :id="`token-${keyItem}`"
                            >
                                {{ real_token_symbol }}
                            </span>
                        </div>
                    </b-col>
                    <b-col cols="6" class="text-right">
                        Max:
                        <div>
                            <span
                                :id="`max-${keyItem}`"
                                v-bind:class="getNumberClass(fixMax.length)"
                            >
                                {{ moneyFormat(fixMax) }}
                            </span>
                            <span style="text-transform:uppercase">
                                {{ real_token_symbol }}
                            </span>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="12">
                <b-progress
                    :value="currBalance"
                    :max="max_deposits"
                    class="mb-1 mt-1"
                ></b-progress>
            </b-col>
            <b-col cols="12" class="">
                <b-row no-gutters>
                    <b-col cols="5" class="text-left">
                        Your Position
                    </b-col>
                    <b-col cols="7" class="text-right" :id="`position-${keyItem}`">
                        {{ position ? `${position.toLocaleString()} ${real_token_symbol.toUpperCase()}` : "---" }}
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
    data() {
        return {};
    },
    computed: {
        fixDeposit() {
            if(this.currBalance > this.max_deposits){
                return this.max_deposits;
            } else return this.currBalance;
        },
        fixMax() {
            return this.max_deposits;
        }
    },
    props: {
        position: {
            default: ""
        },
        deposits: {
            default: 0
        },
        token: {
            default: "USDC"
        },
        max_deposits: {
            default: 0
        },
        type: {
            type: String
        },
        network: {
            type: String
        },
        keyItem: {
            type: Number
        },
        currBalance: {
            type: Number
        },
        real_token_symbol:{
            type: String,
        }
    },
    methods:{
        getNumberClass(length){
            if(length > 17) return "number-overflow";
        }
    }
};
</script>
<style lang="scss">
@import "./resources/sass/_variables.scss";

.fault-bar {
    margin: auto;
    width: 100%;

    .text-deposit {
        font-family: Exo;
        font-style: normal;
        font-weight: 600;
        font-size: 10px; //$small-x-text;
        // font-size: 10px;
        line-height: 18px;
        color: $primary-4;
        margin: auto;

        @media only screen and (min-width: 1440px) {
            font-size: 0.6944444444444444vw;
            line-height: 1.25vw;
        }
    }

    .number-overflow {
        font-size: 9px;
        @media only screen and (min-width: 1440px) {
            font-size: 0.5944444444444444vw;
        }
    }

    .progress {
        height: 8px !important;
        background-color: #e1e1e1 !important;
        //mix-blend-mode: multiply;
        box-shadow: inset 2px 2px 70px rgba(0, 0, 0, 0.25),
            inset 2px 2px 25px rgba(0, 0, 0, 0.44);
    }
}
@media screen and (min-width: 0px) and (max-width: 768px) {
    .fault-bar {
        .text-deposit {
            font-size: 10px;
        }
    }
}
</style>
